import { HabitSchedule } from '@griply/types';
import {
  getSchedulesPerfectSlots,
  GetSchedulesPerfectSlotsOptions,
} from '@griply/utils';
import { useMemo } from 'react';

export type Options = GetSchedulesPerfectSlotsOptions;

export const useSchedulesPerfectSlots = (
  schedules: HabitSchedule[],
  { startDate, endDate, weekStartsOn, today, strictDates }: Options,
) =>
  useMemo(
    () =>
      getSchedulesPerfectSlots(schedules, {
        startDate,
        endDate,
        weekStartsOn,
        today,
        strictDates,
      }),
    [endDate, schedules, startDate, strictDates, today, weekStartsOn],
  );
